import React from "react";
import { PhoneCall, MapPin, Clock, ArrowRight } from "lucide-react";
import { contact, workingHours } from "@/mock/zebraCarsMock";

export const ContactSection = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${contact.phone}`;
  };

  const handleMapClick = () => {
    window.open(contact.googleMapsUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="kontakt" className="py-24 !bg-[#303030]">
      <div className="container max-w-[87.5rem] lg:px-10 grid grid-cols-1 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1.4fr)] items-start !pt-[11px] !pl-[20px] !pr-[20px] !gap-[48px] !bg-[rgba(48,48,48,0)]">
        <div className="space-y-6">
          <p className="caption text-[var(--text-secondary)]">KONTAKT</p>
          <h2 className="heading-2 text-[var(--text-primary)] mb-4">Brz kontakt i jednostavan dolazak</h2>

          <div className="space-y-3 body-medium !my-[70px] text-[#dfddd6]">
            <div className="flex items-center gap-3">
              <PhoneCall className="w-5 h-5 text-[var(--text-primary)]" />
              <a href={`tel:${contact.phone}`} className="link-text">
                {contact.phoneDisplay}
              </a>
            </div>
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[var(--text-primary)] mt-1" />
              <div>
                <p>{contact.address}</p>
                <button
                  onClick={handleMapClick}
                  className="mt-2 inline-flex items-center gap-2 text-sm text-[var(--text-primary)] underline-offset-4 hover:underline">

                  Otvori u Google mapama
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div id="radno-vreme" className="!mt-[70px]">
            <h3 className="heading-5 flex items-center mb-3 gap-2 text-[var(--text-primary)]">
              <Clock className="w-4 h-4" />
              Radno vreme
            </h3>
            <div className="space-y-1 body-small text-[var(--text-primary)]">
              {workingHours.map((item) =>
              <div key={item.day} className="flex justify-between max-w-xs">
                  <span>{item.day}</span>
                  <span className="text-[var(--text-primary)]">{item.hours}</span>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-wrap !pt-[120px] !gap-[16px]">
            <button
              onClick={handleCallClick}
              className="btn-primary btn-hover-scale inline-flex items-center gap-2">

              <PhoneCall className="w-4 h-4" />
              Pozovi odmah
            </button>
            <button
              onClick={handleMapClick}
              className="btn-secondary btn-hover-scale inline-flex items-center gap-2">

              Pokreni navigaciju
            </button>
          </div>
        </div>

        <div className="!opacity-[0%]">
          <iframe
            title="Zebra Cars mapa"
            src={contact.googleMapsUrl}
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade" />

        </div>
      </div>
    </section>);

};

export default ContactSection;